module.exports = __webpack_public_path__ + "static/media/subscription-section-8.084647d6.png";